import { render, staticRenderFns } from "./DteEmitidoVista.vue?vue&type=template&id=2d4b270c&scoped=true"
import script from "./DteEmitidoVista.vue?vue&type=script&lang=js"
export * from "./DteEmitidoVista.vue?vue&type=script&lang=js"
import style0 from "./DteEmitidoVista.vue?vue&type=style&index=0&id=2d4b270c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b270c",
  null
  
)

export default component.exports